import { render, staticRenderFns } from "./http-exception.vue?vue&type=template&id=6920354a&"
import script from "./http-exception.vue?vue&type=script&lang=js&"
export * from "./http-exception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports